export default function SCROLL_NAV(query='.p-gnav',prefix=query.replace(/^[.#](.+)$/,'$1')) {
  const [w,d] = [window,document]
  const container = d.querySelector(query)
  const nav = d.querySelector(query+'__inner')
  let alive = false
  const btn_prev = $(`<button class="${prefix}__btn is-prev" disabled><i class="fa fa-angle-left fa-lg"></i></button>`)[0]
  const btn_next = $(`<button class="${prefix}__btn is-next" disabled><i class="fa fa-angle-right fa-lg"></i></button>`)[0]
  const disp_arr = (pos,max_pos) => {
    if(max_pos > 0)     btn_next.removeAttribute('disabled')
    if(pos > 0)         btn_prev.removeAttribute('disabled')
    if(pos < 10)        btn_prev.setAttribute('disabled',true)
    if(pos >= max_pos)  btn_next.setAttribute('disabled',true)
  }
  const scroll_nav = d => $(nav).animate({'scrollLeft':nav.scrollLeft + d},300,'easeInOutCubic')

  $(container).append(btn_next).prepend(btn_prev)
  
  disp_arr(0, nav.scrollWidth - nav.clientWidth - 10) // 初期化
  w.addEventListener('resize',() => disp_arr(0, nav.scrollWidth - nav.clientWidth - 10))

  nav.addEventListener('scroll',() => {
    if(alive) return false
    const max_pos = nav.scrollWidth - nav.clientWidth - 10
    alive = true
    setTimeout(()=> {
      disp_arr(nav.scrollLeft, max_pos)
      alive = false
    },50)
  })
  $(d).on('click',`${query}__btn`,e => {
    if( e.currentTarget.classList.contains('is-prev') ) scroll_nav(nav.clientWidth * -1)
    if( e.currentTarget.classList.contains('is-next') ) scroll_nav(nav.clientWidth)
  })
}